import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CoinComponent as PuCoinComponent, IconModule, IconSize } from '@hglobal/common';
import { environment } from '@pt/environment';

@Component({
  selector: 'pt-coin',
  template: '<pu-coin [envShortName]="envShortName" [size]="size()"/>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconModule, PuCoinComponent],
})
export class CoinComponent {
  size = input<IconSize>('16');
  readonly envShortName = environment.shortName;
}
